import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'
import saveStreamcExcel from '../../../infra/helper/saveStreamEXCEL';

export default (jobid, type,fileName) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    var body = {
        "jobid":jobid,
        "type":type
    };

    const Authorization = UserToken;
    const url = ApiUrl2 + 'check-contact-download';
    const argument = {
        method: 'POST',
        headers : {
            'Authorization': Authorization,
        },
        body : JSON.stringify(body)
    };

    const response = await doFetch(url,argument);
    if(response.ok){
        console.log(response)
        //debugger
        var responseText = await response.text();
        saveStreamcExcel(fileName, responseText)
    }
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });
    return response;
};